import Vue from 'vue';
import VueRouter from 'vue-router'
import Auth from './views/_Auth'
import Index from './components/Index'
import UsuPainel from './components/Painel'
// Tabela SERVICOS
//import ServicosView from './components/tabelas/servicos/View'
import ServicosAprovacao from './components/tabelas/servicos/aprovacao'
import Servicos from './components/tabelas/servicos/Servicos'
import ServicosEditar from './components/tabelas/servicos/ServicosEditar'
//import ServicosView from './components/tabelas/servicos/View'
import Blog from './components/blog/blog'
import BlogEditar from './components/blog/blogEditar'
// servicos
//import _servicosView from './components/servicos/View'
import _servicos from './components/servicos/servicos'
import _servicosEditar from './components/servicos/servicosEditar'
// emails
//import emailsView from './components/emails/View'
import emails from './components/emails/emails'
import emailsEditar from './components/emails/emailsEditar'
// USUARIOS
//import UsuariosView from './components/tabelas/usuarios/View'
import Usuarios from './components/tabelas/usuarios/Usuarios'
import UsuariosEditar from './components/tabelas/usuarios/UsuariosEditar'

// PORTES EMPRESAS
//import PortesEmpresasView from './components/tabelas/portesEmpresas/View'
import PortesEmpresasAprovacao from './components/tabelas/portesEmpresas/aprovacao'
import PortesEmpresas from './components/tabelas/portesEmpresas/PortesEmpresas'
import PortesEmpresasEditar from './components/tabelas/portesEmpresas/PortesEmpresasEditar'

// Periodos
//import PeriodosView from './components/tabelas/periodos/View'
import PeriodosAprovacao from './components/tabelas/periodos/aprovacao'
import Periodos from './components/tabelas/periodos/Periodos'
import PeriodosEditar from './components/tabelas/periodos/PeriodosEditar'
// marcas
//import marcasView from './components/tabelas/marcas/View'
import marcasAprovacao from './components/tabelas/marcas/aprovacao'
import marcas from './components/tabelas/marcas/marcas'
import marcasEditar from './components/tabelas/marcas/marcasEditar'

// modelos
////import modelosView from './components/tabelas/modelos/View'
import modelosAprovacao from './components/tabelas/modelos/aprovacao'
import modelos from './components/tabelas/modelos/modelos'
import modelosEditar from './components/tabelas/modelos/modelosEditar'

// insumos
//import insumosView from './components/tabelas/insumos/View'
import insumosAprovacao from './components/tabelas/insumos/aprovacao'
import insumos from './components/tabelas/insumos/insumos'
import insumosEditar from './components/tabelas/insumos/insumosEditar'

// funcoes
////import funcoesView from './components/tabelas/funcoes/View'
import funcoesAprovacao from './components/tabelas/funcoes/aprovacao'
import funcoes from './components/tabelas/funcoes/funcoes'
import funcoesEditar from './components/tabelas/funcoes/funcoesEditar'
// funcoes
////import ferramentasView from './components/tabelas/ferramentas/View'
import ferramentasAprovacao from './components/tabelas/ferramentas/aprovacao'
import ferramentas from './components/tabelas/ferramentas/ferramentas'
import ferramentasEditar from './components/tabelas/ferramentas/ferramentasEditar'

// custos variaveis
////import custosVariaveisView from './components/tabelas/custosVariaveis/View'
import custosVariaveisAprovacao from './components/tabelas/custosVariaveis/aprovacao'
import custosVariaveis from './components/tabelas/custosVariaveis/custosVariaveis'
import custosVariaveisEditar from './components/tabelas/custosVariaveis/custosVariaveisEditar'
// custos fixos
////import custosFixosView from './components/tabelas/custosFixos/View'
import custosFixosAprovacao from './components/tabelas/custosFixos/aprovacao'
import custosFixos from './components/tabelas/custosFixos/custosFixos'
import custosFixosEditar from './components/tabelas/custosFixos/custosFixosEditar'
// beneficios
//import beneficiosView from './components/tabelas/beneficios/View'
import beneficiosAprovacao from './components/tabelas/beneficios/aprovacao'
import beneficios from './components/tabelas/beneficios/beneficios'
import beneficiosEditar from './components/tabelas/beneficios/beneficiosEditar'
// ativosFixos
//import ativosFixosView from './components/tabelas/ativosFixos/View'
import ativosFixosAprovacao from './components/tabelas/ativosFixos/aprovacao'
import ativosFixos from './components/tabelas/ativosFixos/ativosFixos'
import ativosFixosEditar from './components/tabelas/ativosFixos/ativosFixosEditar'
// setores
//import setoresView from './components/tabelas/setores/View'
import setoresAprovacao from './components/tabelas/setores/aprovacao'
import setores from './components/tabelas/setores/setores'
import setoresEditar from './components/tabelas/setores/setoresEditar'

// regimesContratacao
//import regimesContratacaoView from './components/tabelas/regimescontratacao/View'
import regimesContratacaoAprovacao from './components/tabelas/regimescontratacao/aprovacao'
import regimesContratacao from './components/tabelas/regimescontratacao/regimesContratacao'
import regimesContratacaoEditar from './components/tabelas/regimescontratacao/regimesContratacaoEditar'

// regimestributarios
//import regimestributariosView from './components/tabelas/regimestributarios/View'
import regimestributariosAprovacao from './components/tabelas/regimestributarios/aprovacao'
import regimestributarios from './components/tabelas/regimestributarios/regimestributarios'
import regimestributariosEditar from './components/tabelas/regimestributarios/regimestributariosEditar'

// clients
//import regimestributariosView from './components/tabelas/regimestributarios/View'
import clientes from './components/clientes/clientes'
import clientescadastro from './components/clientes/cadastro'
import clientescontratos from './components/clientes/contratos'

import clientecontratoInicio from './components/clientes/contrato/etapa_1/etapa_1'
import clientecontratoetapa2 from './components/clientes/contrato/etapa_2/etapa_2'
import clientecontratoetapa3 from './components/clientes/contrato/etapa_3/etapa_3'
import clientecontratoetapa4 from './components/clientes/contrato/etapa_4/etapa_4'
import clientecontratoetapa5 from './components/clientes/contrato/etapa_5/etapa_5'
import clientecontratoetapa5A from './components/clientes/contrato/etapa_5/etapa_5A'
import clientecontratoetapa5B from './components/clientes/contrato/etapa_5/etapa_5B'
import clientecontratoetapa6 from './components/clientes/contrato/etapa_6/etapa_6'
import clientecontratoetapa7 from './components/clientes/contrato/etapa_7/etapa_7'
import clientecontratoetapa8 from './components/clientes/contrato/etapa_8/etapa_8'
import clientecontratoetapa9 from './components/clientes/contrato/etapa_9/etapa_9'
import clientecontratoetapa10 from './components/clientes/contrato/etapa_10/etapa_10'
import clientecontratoetapa11 from './components/clientes/contrato/etapa_11/etapa_11'
import clientecontratoetapa12 from './components/clientes/contrato/etapa_12/etapa_12'
import clientecontratoetapa13 from './components/clientes/contrato/etapa_13/etapa_13'
import ClienteContrato from './components/clientes/contrato/View'



// Area do cliente
import AuthCliente from './cliente/Auth'
import Cliente from './cliente/View'
import ClienteContratar from './cliente/Contratar'
import ClientePainel from './cliente/Painel'
import ClientetCadastro from './cliente/Cadastro'

    // Contrato
import Contrato from './cliente/contrato/View'
import contratoInicio from './cliente/contrato/etapa_1/etapa_1'
import contratoetapa2 from './cliente/contrato/etapa_2/etapa_2'
import contratoetapa3 from './cliente/contrato/etapa_3/etapa_3'
import contratoetapa4 from './cliente/contrato/etapa_4/etapa_4'
import contratoetapa5 from './cliente/contrato/etapa_5/etapa_5'
import contratoetapa5A from './cliente/contrato/etapa_5/etapa_5A'
import contratoetapa5B from './cliente/contrato/etapa_5/etapa_5B'
import contratoetapa6 from './cliente/contrato/etapa_6/etapa_6'
import contratoetapa7 from './cliente/contrato/etapa_7/etapa_7'
import contratoetapa8 from './cliente/contrato/etapa_8/etapa_8'
import contratoetapa9 from './cliente/contrato/etapa_9/etapa_9'
import contratoetapa10 from './cliente/contrato/etapa_10/etapa_10'
import contratoetapa11 from './cliente/contrato/etapa_11/etapa_11'
import contratoetapa12 from './cliente/contrato/etapa_12/etapa_12'
import contratoetapa13 from './cliente/contrato/etapa_13/etapa_13'
import contratoimprimir from './cliente/contrato/etapa_13/imprimir'


// Area do cliente
import AuthGape from './gape/Auth'
import GapePainel from './gape/Painel'
import GapeView from './gape/View'
import GapeFormInteresse from './gape/FormInteresse'
import GapeFormContato from './gape/FormContato'
import GapeIdiomas from './gape/idiomas/idiomas'
import GapeIdiomasEditar from './gape/idiomas/idiomasEditar'

import GapeConfiguracoes from './gape/configuracoes/configuracoes'
import GapeConfiguracoesEditar from './gape/configuracoes/configuracoesEditar'

import Gapehome from './gape/home/home'
import GapehomeEditar from './gape/home/homeEditar'

import GapequemSomos from './gape/quemSomos/quemSomos'
import GapequemSomosEditar from './gape/quemSomos/quemSomosEditar'

import Gapecontato from './gape/contato/contato'
import GapecontatoEditar from './gape/contato/contatoEditar'

import Gapeartigos from './gape/artigos/artigos'
import GapeartigosEditar from './gape/artigos/artigosEditar'

import Gapebanners from './gape/banners/banners'
import GapebannersEditar from './gape/banners/bannersEditar'

import Gapeclientes from './gape/clientes/clientes'
import GapeclientesEditar from './gape/clientes/clientesEditar'

import Gapedepoimentos from './gape/depoimentos/depoimentos'
import GapedepoimentosEditar from './gape/depoimentos/depoimentosEditar'

import GapesegmentosConfiguracoes from './gape/segmentosConfiguracoes/segmentosConfiguracoes'
import GapesegmentosConfiguracoesEditar from './gape/segmentosConfiguracoes/segmentosConfiguracoesEditar'

import Gapesegmentos from './gape/segmentos/segmentos'
import GapesegmentosEditar from './gape/segmentos/segmentosEditar'

import Gapeimagens from './gape/imagens/imagens'
import GapeimagensEditar from './gape/imagens/imagensEditar'

import Gapeservicos from './gape/servicos/servicos'
import GapeservicosEditar from './gape/servicos/servicosEditar'

import Gapeequipe from './gape/equipe/equipe'
import GapeequipeEditar from './gape/equipe/equipeEditar'

import Gapeespecializacoes from './gape/especializacoes/especializacoes'
import GapeespecializacoesEditar from './gape/especializacoes/especializacoesEditar'

//

//AutoEspecialiastas
import AuthAuto from './autoespecialistas/Auth'
import AutoPainel from './autoespecialistas/Painel'
import AutoView from './autoespecialistas/View'
import AutoFormInteresse from './autoespecialistas/FormInteresse'
import AutoFormContato from './autoespecialistas/FormContato'
import AutoFormEquipe from './autoespecialistas/FormEquipe'

import Autodepoimentos from './autoespecialistas/depoimentos/depoimentos'
import AutodepoimentosEditar from './autoespecialistas/depoimentos/depoimentosEditar'

import AutosegmentosConfiguracoes from './autoespecialistas/segmentosConfiguracoes/segmentosConfiguracoes'
import AutosegmentosConfiguracoesEditar from './autoespecialistas/segmentosConfiguracoes/segmentosConfiguracoesEditar'

import Autosegmentos from './autoespecialistas/segmentos/segmentos'
import AutosegmentosEditar from './autoespecialistas/segmentos/segmentosEditar'

import Autoimagens from './autoespecialistas/imagens/imagens'
import AutoimagensEditar from './autoespecialistas/imagens/imagensEditar'

import Autoservicos from './autoespecialistas/servicos/servicos'
import AutoservicosEditar from './autoespecialistas/servicos/servicosEditar'
import AutoConfiguracoesEditar from './autoespecialistas/configuracoes/configuracoesEditar'
import Autobanners from './autoespecialistas/banners/banners'
import AutobannersEditar from './autoespecialistas/banners/bannersEditar'

//Esinistros
import AuthEsinistros from './esinistros/Auth'
import EsinistrosPainel from './esinistros/Painel'
import EsinistrosView from './esinistros/View'
import EsinistrosFormInteresse from './esinistros/FormInteresse'
import EsinistrosFormContato from './esinistros/FormContato'
import EsinistrosFormEquipe from './esinistros/FormEquipe'

import Esinistrosdepoimentos from './esinistros/depoimentos/depoimentos'
import EsinistrosdepoimentosEditar from './esinistros/depoimentos/depoimentosEditar'

import EsinistrossegmentosConfiguracoes from './esinistros/segmentosConfiguracoes/segmentosConfiguracoes'
import EsinistrossegmentosConfiguracoesEditar from './esinistros/segmentosConfiguracoes/segmentosConfiguracoesEditar'

import Esinistrossegmentos from './esinistros/segmentos/segmentos'
import EsinistrossegmentosEditar from './esinistros/segmentos/segmentosEditar'

import Esinistrosimagens from './esinistros/imagens/imagens'
import EsinistrosimagensEditar from './esinistros/imagens/imagensEditar'

import Esinistrosservicos from './esinistros/servicos/servicos'
import EsinistrosservicosEditar from './esinistros/servicos/servicosEditar'
import EsinistrosConfiguracoesEditar from './esinistros/configuracoes/configuracoesEditar'
import Esinistrosbanners from './esinistros/banners/banners'
import EsinistrosbannersEditar from './esinistros/banners/bannersEditar'

//Esinistros

import AuthEoficinas from './eoficinas/Auth'
import EoficinasPainel from './eoficinas/Painel'
import EoficinasView from './eoficinas/View'
import EoficinasFormInteresse from './eoficinas/FormInteresse'
import EoficinasFormContato from './eoficinas/FormContato'
import EoficinasFormEquipe from './eoficinas/FormEquipe'

import Eoficinasdepoimentos from './eoficinas/depoimentos/depoimentos'
import EoficinasdepoimentosEditar from './eoficinas/depoimentos/depoimentosEditar'

import EoficinassegmentosConfiguracoes from './eoficinas/segmentosConfiguracoes/segmentosConfiguracoes'
import EoficinassegmentosConfiguracoesEditar from './eoficinas/segmentosConfiguracoes/segmentosConfiguracoesEditar'

import Eoficinassegmentos from './eoficinas/segmentos/segmentos'
import EoficinassegmentosEditar from './eoficinas/segmentos/segmentosEditar'

import Eoficinasimagens from './eoficinas/imagens/imagens'
import EoficinasimagensEditar from './eoficinas/imagens/imagensEditar'

import Eoficinasservicos from './eoficinas/servicos/servicos'
import EoficinasservicosEditar from './eoficinas/servicos/servicosEditar'
import EoficinasConfiguracoesEditar from './eoficinas/configuracoes/configuracoesEditar'
import Eoficinasbanners from './eoficinas/banners/banners'
import EoficinasbannersEditar from './eoficinas/banners/bannersEditar'

import {userKey} from './global/utils'

Vue.use(VueRouter)

const  routes =[
        {
            path:'/paineldegerenciamento/auth',
            name: 'auth',
            components:{
                auth: Auth,
            },
            props: false
        },
        {
            path:'/paineldegerenciamento',
            components:{
                default:Index,
                
            },
            props: false,
            meta: { breadcrumb: 'Painel' },
            children:[
                {
                    path:'', 
                    name: 'telaPaienl',
                    props: true,
                    component: UsuPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
            ]

        },        
        {
            path:'/paineldegerenciamento/listaservicos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'servicosLista',
                    props: true,
                    component: Servicos,
                    meta: {
                        acessoAmin: true,
                    },
                },
                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  component: ServicosAprovacao,
                  meta: {
                      acessoAmin: true,
                  },
              },                
                {
                    path:':id/editar', 
                    name: 'servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: ServicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: ServicosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listausuarios',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'UsuariosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Usuários'
                    },
                            component: Usuarios,
                },                
                {
                    path:':id/editar', 
                    name: 'usuariosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Usuários - Editar'

                    },
                    components:{
                        default: UsuariosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'usuariosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Usuários - Novo'
                    },
                    components:{
                        default: UsuariosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaportesempresas',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'portesEmrpesasLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: PortesEmpresas,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: PortesEmpresasAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'portesEmrpesasEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: PortesEmpresasEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'portesEmrpesasNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: PortesEmpresasEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaperiodos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'periodosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: Periodos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: PeriodosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'periodosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: PeriodosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'periodosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: PeriodosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listamarcas',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'marcasLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: marcas,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: marcasAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'marcasEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: marcasEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'marcasNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: marcasEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listamarcas/:idMarca/modelos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'modelosLista1',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: modelos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: modelosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'modelosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: modelosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'modelosNovo1',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: modelosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listamodelos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'modelosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: modelos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: modelosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'modelosEditar2',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: modelosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'modelosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: modelosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/blog',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'Bloglista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: Blog,
                },                
                {
                    path:':id/editar', 
                    name: 'bklogEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: BlogEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'blogNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: BlogEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listainsumos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'insumosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: insumos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: insumosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'insumosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: insumosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'insumosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: insumosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listafuncoes',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'funcoesLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: funcoes,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: funcoesAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'funcoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: funcoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'funcoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: funcoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaferramentas',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'ferramentasLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: ferramentas,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: ferramentasAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'ferramentasEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: ferramentasEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ferramentasNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: ferramentasEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listacustosvariaveis',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'custosVariaveisLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: custosVariaveis,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: custosVariaveisAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'custosVariaveisEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: custosVariaveisEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'custosVariaveisNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: custosVariaveisEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listacustosFixos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'custosFixosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: custosFixos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: custosFixosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'custosFixosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: custosFixosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'custosFixosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: custosFixosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listabeneficios',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'beneficiosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: beneficios,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: beneficiosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'beneficiosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: beneficiosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'beneficiosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: beneficiosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaativosFixos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'ativosFixosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    component: ativosFixos,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: ativosFixosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'ativosFixosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: ativosFixosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ativosFixosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: ativosFixosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listasetores',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'setoresLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: setores,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: setoresAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'setoresEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: setoresEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'setoresNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: setoresEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaregimesContratacao',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'regimesContratacaoLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: regimesContratacao,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: regimesContratacaoAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'regimesContratacaoEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: regimesContratacaoEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'regimesContratacaoNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: regimesContratacaoEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/listaregimestributarios',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'regimestributariosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: regimestributarios,
                },                {
                  path:'aprovacao', 
                  name: 'aprovacao',
                  props: true,
                  meta: {
                      acessoAmin: true,
                  },
                          component: regimestributariosAprovacao,
                },                
                {
                    path:':id/editar', 
                    name: 'regimestributariosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: regimestributariosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'regimestributariosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: regimestributariosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/servicos/:servicoId/emails',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: 'emailsLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: emails,
                },                
                {
                    path:':id/editar', 
                    name: 'emailsEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: emailsEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'emailsNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: emailsEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/servicos',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: '_servicosLista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: _servicos,
                },                
                {
                    path:':id/editar', 
                    name: '_servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: _servicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: '_servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: _servicosEditar,
                    }
                }
            ]
        },        
        {
            path:'/paineldegerenciamento/clientes',
            components:{
                default:Index,
                
            },
            meta: {
                acessoAmin: true,
            },
           props:true,
            children:[
                {
                    path:'', 
                    name: '_clientes',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                            component: clientes,
                },                
                {
                    path:'cadastro/:id', 
                    name: '_clienteseditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: clientescadastro,
                    }

                },
                {
                    path:'contratos/:id', 
                    name: 'clienteContratolista',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: clientescontratos,
                    }
                }
            ]
        },        
        {
            path:'/areacliente/auth',
            components:{
                default:AuthCliente,
                

            },
            meta:{
                logado: false
            },
           props:true,
            children:[
                {
                    path:'',
                    name: 'authnull',
                    props: true,
                    meta: {
                        logado: false,
                    },
                            component: AuthCliente,
                },                
                {
                    path:':idServico/servico', 
                    name: 'cadastro',
                    props: true,
                    meta: {
                        logado: false,
                    },
                            component: AuthCliente,
                },                
                {
                    path:':idServico', 
                    name: 'cadastroid',
                    props: true,
                    meta: {
                        logado: false,
                    },
                            component: AuthCliente,
                },
                {
                    path:'novo', 
                    name: 'cadastroNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                    },
                    components:{
                        default: AuthCliente,
                    }
                }
            ]
        },             
        {
            path:'/areacliente/contrato/etapa1', 
            name: 'areaclienteContrato',
            props: true,
            meta: {
                areacliente: true,
                etapa_01: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'etapa1',
                    props: true,
                    meta: {
                        areacliente: true,
                        etapa_01: true,
                    },
                    components:{
                        default: contratoInicio,
                    }
                },
                {
                    path:':codigoContrato/:idEtapa', 
                    name: 'areaclienteContratada',
                    props: true,
                    meta: {
                        areacliente: true,
                        etapa_01: true,
                    },
                    components:{
                        default: contratoInicio,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa2/', 
            name: 'areaclienteContratoEtapa2',
            props: true,
            meta: {
                areacliente: true,
                etapa_02: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa2',
                    props: true,
                    meta: {
                        areacliente: true,
                        etapa_02: true,
                    },
                    components:{
                        default: contratoetapa2,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa3/', 
            name: 'areaclienteContratoEtapa3',
            props: true,
            meta: {
                areacliente: true,
                etapa_03: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa3',
                    props: true,
                    meta: {
                        areacliente: true,
                        etapa_03: true,

                    },
                    components:{
                        default: contratoetapa3,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa4/', 
            name: 'areaclienteContratoEtapa4',
            props: true,
            meta: {
                areacliente: true,
                etapa_04: true,

            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa4',
                    props: true,
                    meta: {
                        etapa_04: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa4,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa5/', 
            name: 'areaclienteContratoEtapa5',
            props: true,
            meta: {
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa5',
                    props: true,
                    meta: {
                        etapa_05: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa5,
                    }
                },
                {
                    path:':codigoContrato/funcoes/:etapaId', 
                    name: 'areaclienteContrato_Etapa5A',
                    props: true,
                    meta: {
                        etapa_05: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa5A,
                    }
                },
                {
                    path:':codigoContrato/beneficios/:etapaId', 
                    name: 'areaclienteContrato_Etapa5B',
                    props: true,
                    meta: {
                        etapa_05: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa5B,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa6/', 
            name: 'areaclienteContratoEtapa6',
            props: true,
            meta: {
                areacliente: true,
                etapa_06: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa6',
                    props: true,
                    meta: {
                        etapa_06: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa6,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa7/', 
            name: 'areaclienteContratoEtapa7',
            props: true,
            meta: {
                etapa_07: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa7',
                    props: true,
                    meta: {
                        etapa_07: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa7,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa8/', 
            name: 'areaclienteContratoEtapa8',
            props: true,
            meta: {
                etapa_08: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa8',
                    props: true,
                    meta: {
                        etapa_08: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa8,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa9/', 
            name: 'areaclienteContratoEtapa9',
            props: true,
            meta: {
                etapa_09: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa9',
                    props: true,
                    meta: {
                        etapa_09: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa9,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa10/', 
            name: 'areaclienteContratoEtapa10',
            props: true,
            meta: {
                etapa_10: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa10',
                    props: true,
                    meta: {
                        etapa_10: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa10,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa11/', 
            name: 'areaclienteContratoEtapa11',
            props: true,
            meta: {
                etapa_11: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa11',
                    props: true,
                    meta: {
                        etapa_11: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa11,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa12/', 
            name: 'areaclienteContratoEtapa12',
            props: true,
            meta: {
                etapa_12: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa12',
                    props: true,
                    meta: {
                        etapa_12: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa12,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa13/', 
            name: 'areaclienteContratoEtapa13',
            props: true,
            meta: {
                etapa_13: true,
                areacliente: true,
            },
            components:{
                default: Contrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa13',
                    props: true,
                    meta: {
                        etapa_13: true,
                        areacliente: true,
                    },
                    components:{
                        default: contratoetapa13,
                    }
                }
            ]
        },                
        {
            path:'/areacliente/contrato/etapa13/imprimir', 
            name: 'imprimir',
            props: true,
            meta: {
                etapa_13: true,
                areacliente: true,
            },
            components:{
                default: contratoimprimir,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'areaclienteContrato_Etapa13',
                    props: true,
                    meta: {
                        etapa_13: true,
                        areacliente: true,
                    },
                    components:{
                    }
                }
            ]
        },                
        {
            path:'/areacliente', 
            props: true,
            meta: {
                areacliente: true,
                logado: true
            },
            components:{
                default: Cliente,
            },
            children:[
                {
                    path:'', 
                    alias:'painel',
                    name: 'areaclientePainel',
                    props: true,
                    meta: {
                        areacliente: true,
                    },
                    components:{
                        default: ClientePainel,
                    }
                }, {
                    path:':idServico/contratar', 
                    name: 'clienteContratar',
                    props: true,
                    meta: {
                        areacliente: true,
                    },
                    components:{
                        default: ClienteContratar,
                    }
                }, {
                    path:'cadastro', 
                    name: 'clientecadastro',
                    props: true,
                    meta: {
                        areacliente: true,
                    },
                    components:{
                        default: ClientetCadastro,
                    }
                }
            ]
        },             
        {
            path:'/paineldegerenciamento/contrato/etapa1', 
            name: 'painelgerenciamentoContrato',
            props: true,
            meta: {
                painelgerenciamento: true,
                etapa_01: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'etapa1',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                        etapa_01: true,
                    },
                    components:{
                        default: clientecontratoInicio,
                    }
                },
                {
                    path:':codigoContrato/:idEtapa', 
                    name: 'painelgerenciamentoContratada',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                        etapa_01: true,
                    },
                    components:{
                        default: clientecontratoInicio,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa2/', 
            name: 'painelgerenciamentoclientecontratoetapa2',
            props: true,
            meta: {
                painelgerenciamento: true,
                etapa_02: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa2',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                        etapa_02: true,
                    },
                    components:{
                        default: clientecontratoetapa2,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa3/', 
            name: 'painelgerenciamentoclientecontratoetapa3',
            props: true,
            meta: {
                painelgerenciamento: true,
                etapa_03: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa3',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                        etapa_03: true,

                    },
                    components:{
                        default: clientecontratoetapa3,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa4/', 
            name: 'painelgerenciamentoclientecontratoetapa4',
            props: true,
            meta: {
                painelgerenciamento: true,
                etapa_04: true,

            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa4',
                    props: true,
                    meta: {
                        etapa_04: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa4,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa5/', 
            name: 'painelgerenciamentoclientecontratoetapa5',
            props: true,
            meta: {
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa5',
                    props: true,
                    meta: {
                        etapa_05: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa5,
                    }
                },
                {
                    path:':codigoContrato/funcoes/:etapaId', 
                    name: 'painelgerenciamentoContrato_Etapa5A',
                    props: true,
                    meta: {
                        etapa_05: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa5A,
                    }
                },
                {
                    path:':codigoContrato/beneficios/:etapaId', 
                    name: 'painelgerenciamentoContrato_Etapa5B',
                    props: true,
                    meta: {
                        etapa_05: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa5B,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa6/', 
            name: 'painelgerenciamentoclientecontratoetapa6',
            props: true,
            meta: {
                painelgerenciamento: true,
                etapa_06: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa6',
                    props: true,
                    meta: {
                        etapa_06: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa6,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa7/', 
            name: 'painelgerenciamentoclientecontratoetapa7',
            props: true,
            meta: {
                etapa_07: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa7',
                    props: true,
                    meta: {
                        etapa_07: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa7,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa8/', 
            name: 'painelgerenciamentoclientecontratoetapa8',
            props: true,
            meta: {
                etapa_08: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa8',
                    props: true,
                    meta: {
                        etapa_08: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa8,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa9/', 
            name: 'painelgerenciamentoclientecontratoetapa9',
            props: true,
            meta: {
                etapa_09: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa9',
                    props: true,
                    meta: {
                        etapa_09: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa9,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa10/', 
            name: 'painelgerenciamentoclientecontratoetapa10',
            props: true,
            meta: {
                etapa_10: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa10',
                    props: true,
                    meta: {
                        etapa_10: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa10,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa11/', 
            name: 'painelgerenciamentoclientecontratoetapa11',
            props: true,
            meta: {
                etapa_11: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa11',
                    props: true,
                    meta: {
                        etapa_11: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa11,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa12/', 
            name: 'painelgerenciamentoclientecontratoetapa12',
            props: true,
            meta: {
                etapa_12: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa12',
                    props: true,
                    meta: {
                        etapa_12: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa12,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato/etapa13/', 
            name: 'painelgerenciamentoclientecontratoetapa13',
            props: true,
            meta: {
                etapa_13: true,
                painelgerenciamento: true,
            },
            components:{
                default: ClienteContrato,
            },
            children:[
                {
                    path:':codigoContrato', 
                    name: 'painelgerenciamentoContrato_Etapa13',
                    props: true,
                    meta: {
                        etapa_13: true,
                        painelgerenciamento: true,
                    },
                    components:{
                        default: clientecontratoetapa13,
                    }
                }
            ]
        },                
        {
            path:'/paineldegerenciamento/contrato', 
            props: true,
            meta: {
                painelgerenciamento: true,
            },
            components:{
                default: Cliente,
            },
            children:[
                {
                    path:'', 
                    alias:'painel',
                    name: 'painelgerenciamentoPainel',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                    },
                    components:{
                        default: ClientePainel,
                    }
                }, {
                    path:':idServico/contratar', 
                    name: 'clienteContratar',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                    },
                    components:{
                        default: ClienteContratar,
                    }
                }, {
                    path:'cadastro', 
                    name: 'clientecadastro',
                    props: true,
                    meta: {
                        painelgerenciamento: true,
                    },
                    components:{
                        default: ClientetCadastro,
                    }
                }
            ]
        },
        {
            path:'/gape/auth',
            name: 'gapeauth',
            components:{
                auth: AuthGape,
            },
            props: false
        },
        {
            path:'/gape/',
            components:{
                default:GapeView,
            },
            props: false,
            meta: { breadcrumb: 'Painel', logado: true },
            children:[
                {
                    path:'paineldegerenciamento', 
                    name: 'gapepainel',
                    props: true,
                    component: GapePainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'', 
                    name: 'gapepainelhome',
                    props: true,
                    component: GapePainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'forminteresse', 
                    name: 'gapeinteresseform',
                    props: true,
                    component: GapeFormInteresse,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formcontato', 
                    name: 'fapeformcontato',
                    props: true,
                    component: GapeFormContato,
                    meta: {
                        acessoAmin: true,
                    },
                },                
            ]

        },        
        {
            path:'/gape/idiomas',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'idiomas',
                    props: true,
                    component: GapeIdiomas,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'idiomasEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeIdiomasEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'idiomasNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeIdiomasEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/configuracoes',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'configuracoes',
                    props: true,
                    component: GapeConfiguracoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'configuracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/home',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'home',
                    props: true,
                    component: Gapehome,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'homeEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapehomeEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'homeNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapehomeEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/quemSomos',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'quemSomos',
                    props: true,
                    component: GapequemSomos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'quemSomosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapequemSomosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'quemSomosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapequemSomosEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/contato',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'contato',
                    props: true,
                    component: Gapecontato,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'contatoEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapecontatoEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'contatoNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapecontatoEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/artigos',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'artigos',
                    props: true,
                    component: Gapeartigos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'artigosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeartigosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'artigosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeartigosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'artigosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeartigosEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/banners',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'banners',
                    props: true,
                    component: Gapebanners,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'bannersEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapebannersEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'bannersCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapebannersEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'bannersNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapebannersEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/clientes',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'clientes',
                    props: true,
                    component: Gapeclientes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'clientesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeclientesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'clientesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeclientesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'clientesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeclientesEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/depoimentos',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'depoimentos',
                    props: true,
                    component: Gapedepoimentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'depoimentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapedepoimentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'depoimentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapedepoimentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'depoimentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapedepoimentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/equipe',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'equipe',
                    props: true,
                    component: Gapeequipe,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'equipeEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeequipeEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'equipeCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeequipeEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'equipeNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeequipeEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/especializacoes',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'especializacoes',
                    props: true,
                    component: Gapeespecializacoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'especializacoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeespecializacoesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'especializacoesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeespecializacoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'especializacoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeespecializacoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/segmentosConfiguracoes',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentosConfiguracoes',
                    props: true,
                    component: GapesegmentosConfiguracoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosConfiguracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapesegmentosConfiguracoesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosConfiguracoesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapesegmentosConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapesegmentosConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/segmentos',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentos',
                    props: true,
                    component: Gapesegmentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapesegmentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapesegmentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapesegmentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/imagens/:id',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'imagens',
                    props: true,
                    component: Gapeimagens,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'imagensEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeimagensEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'imagensCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeimagensEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'imagensNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeimagensEditar,
                    }
                }
            ]
        },        
        {
            path:'/gape/servicos/:id',
            components:{
                default:GapeView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'servicos',
                    props: true,
                    component: Gapeservicos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':idServico/editar', 
                    name: 'servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: GapeservicosEditar,
                    }

                },                
                {
                    path:':idServico/copiar', 
                    name: 'servicosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: GapeservicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: GapeservicosEditar,
                    }
                }
            ]
        },
        {
            path:'/autoespecialistas/auth',
            name: 'Autoauth',
            components:{
                auth: AuthAuto,
            },
            props: false
        },
        {
            path:'/autoespecialistas/',
            components:{
                default:AutoView,
            },
            props: false,
            meta: { breadcrumb: 'Painel', logado: true },
            children:[
                {
                    path:'paineldegerenciamento', 
                    name: 'Autopainel',
                    props: true,
                    component: AutoPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'', 
                    name: 'Autopainelhome',
                    props: true,
                    component: AutoPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'forminteresse', 
                    name: 'Autointeresseform',
                    props: true,
                    component: AutoFormInteresse,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formcontato', 
                    name: 'fapeformcontato',
                    props: true,
                    component: AutoFormContato,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formequipe', 
                    name: 'autoformequipe',
                    props: true,
                    component: AutoFormEquipe,
                    meta: {
                        acessoAmin: true,
                    },
                },                
            ]

        },        
        {
            path:'/autoespecialistas/configuracoes',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:':id/editar', 
                    name: 'configuracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutoConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutoConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/banners',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'banners',
                    props: true,
                    component: Autobanners,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'bannersEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutobannersEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'bannersCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutobannersEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'bannersNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutobannersEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/depoimentos',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'depoimentos',
                    props: true,
                    component: Autodepoimentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'depoimentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutodepoimentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'depoimentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutodepoimentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'depoimentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutodepoimentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/segmentosConfiguracoes',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentosConfiguracoes',
                    props: true,
                    component: AutosegmentosConfiguracoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosConfiguracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutosegmentosConfiguracoesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosConfiguracoesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutosegmentosConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutosegmentosConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/segmentos',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentos',
                    props: true,
                    component: Autosegmentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutosegmentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutosegmentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutosegmentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/imagens/:id',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'imagens',
                    props: true,
                    component: Autoimagens,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'imagensEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutoimagensEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'imagensCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutoimagensEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'imagensNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutoimagensEditar,
                    }
                }
            ]
        },        
        {
            path:'/autoespecialistas/servicos/:id',
            components:{
                default:AutoView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'servicos',
                    props: true,
                    component: Autoservicos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':idServico/editar', 
                    name: 'servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: AutoservicosEditar,
                    }

                },                
                {
                    path:':idServico/copiar', 
                    name: 'servicosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: AutoservicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: AutoservicosEditar,
                    }
                }
            ]
        },
        {
            path:'/esinistros/auth',
            name: 'Esinistrosauth',
            components:{
                auth: AuthEsinistros,
            },
            props: false
        },
        {
            path:'/esinistros/',
            components:{
                default:EsinistrosView,
            },
            props: false,
            meta: { breadcrumb: 'Painel', logado: true },
            children:[
                {
                    path:'paineldegerenciamento', 
                    name: 'Esinistrospainel',
                    props: true,
                    component: EsinistrosPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'', 
                    name: 'Esinistrospainelhome',
                    props: true,
                    component: EsinistrosPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'forminteresse', 
                    name: 'Esinistrosinteresseform',
                    props: true,
                    component: EsinistrosFormInteresse,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formcontato', 
                    name: 'fapeformcontato',
                    props: true,
                    component: EsinistrosFormContato,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formequipe', 
                    name: 'esinistrosformequipe',
                    props: true,
                    component: EsinistrosFormEquipe,
                    meta: {
                        acessoAmin: true,
                    },
                },                
            ]

        },        
        {
            path:'/esinistros/configuracoes',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:':id/editar', 
                    name: 'configuracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrosConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrosConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/banners',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'banners',
                    props: true,
                    component: Esinistrosbanners,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'bannersEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrosbannersEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'bannersCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrosbannersEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'bannersNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrosbannersEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/depoimentos',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'depoimentos',
                    props: true,
                    component: Esinistrosdepoimentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'depoimentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrosdepoimentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'depoimentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrosdepoimentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'depoimentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrosdepoimentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/segmentosConfiguracoes',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentosConfiguracoes',
                    props: true,
                    component: EsinistrossegmentosConfiguracoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosConfiguracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrossegmentosConfiguracoesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosConfiguracoesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrossegmentosConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrossegmentosConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/segmentos',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentos',
                    props: true,
                    component: Esinistrossegmentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrossegmentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrossegmentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrossegmentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/imagens/:id',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'imagens',
                    props: true,
                    component: Esinistrosimagens,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'imagensEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrosimagensEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'imagensCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrosimagensEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'imagensNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrosimagensEditar,
                    }
                }
            ]
        },        
        {
            path:'/esinistros/servicos/:id',
            components:{
                default:EsinistrosView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'servicos',
                    props: true,
                    component: Esinistrosservicos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':idServico/editar', 
                    name: 'servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EsinistrosservicosEditar,
                    }

                },                
                {
                    path:':idServico/copiar', 
                    name: 'servicosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EsinistrosservicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EsinistrosservicosEditar,
                    }
                }
            ]
        },
        {
            path:'/eoficinas/auth',
            name: 'Eoficinasauth',
            components:{
                auth: AuthEoficinas,
            },
            props: false
        },
        {
            path:'/eoficinas/',
            components:{
                default:EoficinasView,
            },
            props: false,
            meta: { breadcrumb: 'Painel', logado: true },
            children:[
                {
                    path:'paineldegerenciamento', 
                    name: 'Eoficinaspainel',
                    props: true,
                    component: EoficinasPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'', 
                    name: 'Eoficinaspainelhome',
                    props: true,
                    component: EoficinasPainel,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'forminteresse', 
                    name: 'Eoficinasinteresseform',
                    props: true,
                    component: EoficinasFormInteresse,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formcontato', 
                    name: 'fapeformcontato',
                    props: true,
                    component: EoficinasFormContato,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:'formequipe', 
                    name: 'eoficinasformequipe',
                    props: true,
                    component: EoficinasFormEquipe,
                    meta: {
                        acessoAmin: true,
                    },
                },                
            ]

        },        
        {
            path:'/eoficinas/configuracoes',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:':id/editar', 
                    name: 'configuracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinasConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'ConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinasConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/banners',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'banners',
                    props: true,
                    component: Eoficinasbanners,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'bannersEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinasbannersEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'bannersCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinasbannersEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'bannersNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinasbannersEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/depoimentos',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'depoimentos',
                    props: true,
                    component: Eoficinasdepoimentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'depoimentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinasdepoimentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'depoimentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinasdepoimentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'depoimentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinasdepoimentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/segmentosConfiguracoes',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentosConfiguracoes',
                    props: true,
                    component: EoficinassegmentosConfiguracoes,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosConfiguracoesEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinassegmentosConfiguracoesEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosConfiguracoesCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinassegmentosConfiguracoesEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosConfiguracoesNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinassegmentosConfiguracoesEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/segmentos',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'segmentos',
                    props: true,
                    component: Eoficinassegmentos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'segmentosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinassegmentosEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'segmentosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinassegmentosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'segmentosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinassegmentosEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/imagens/:id',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'imagens',
                    props: true,
                    component: Eoficinasimagens,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':id/editar', 
                    name: 'imagensEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinasimagensEditar,
                    }

                },                
                {
                    path:':id/copiar', 
                    name: 'imagensCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinasimagensEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'imagensNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinasimagensEditar,
                    }
                }
            ]
        },        
        {
            path:'/eoficinas/servicos/:id',
            components:{
                default:EoficinasView,
                
            },
            meta: {
                acessoAmin: true,
            },
            props:true,
            children:[
                {
                    path:'', 
                    name: 'servicos',
                    props: true,
                    component: Eoficinasservicos,
                    meta: {
                        acessoAmin: true,
                    },
                },                
                {
                    path:':idServico/editar', 
                    name: 'servicosEditar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Editar'
                    },
                    components:{
                        default: EoficinasservicosEditar,
                    }

                },                
                {
                    path:':idServico/copiar', 
                    name: 'servicosCopiar',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Copiar'
                    },
                    components:{
                        default: EoficinasservicosEditar,
                    }

                },
                {
                    path:'novo', 
                    name: 'servicosNovo',
                    props: true,
                    meta: {
                        acessoAmin: true,
                        breadcrumb: 'Novo'
                    },
                    components:{
                        default: EoficinasservicosEditar,
                    }
                }
            ]
        }
    ]
  
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL, 
    routes
})
router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(userKey)
    if(to.matched.some(record => {
        record.meta.acessoAmin
    })){
        const user = JSON.parse(json)
        console.log(user)
        user && user.isAdmin == "True" ? next() : next({path: '/'})
    }else{
        next()
    }
})
export default router